module.exports = __webpack_public_path__ + "img/410.921f3e23.png";